module.exports = __webpack_public_path__ + "img/gift-13.835326c7.jpg";